import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=c5f441f2&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"
import style0 from "./Issues.vue?vue&type=style&index=0&id=c5f441f2&prod&lang=scss"
import style1 from "./Issues.vue?vue&type=style&index=1&id=c5f441f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f441f2",
  null
  
)

export default component.exports